import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import GlobalSearch from './GlobalSearch';
import { useHotkeys } from 'react-hotkeys-hook';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setGlobalSearch } from '../../redux/uiSlice';

const DRAWER_WIDTH = 240;

export default function AppLayout() {
  const sidebarOpen = useAppSelector((s) => s.ui.sidebarOpen);
  const dispatch = useAppDispatch();

  useHotkeys('mod+k', (e) => {
    e.preventDefault();
    dispatch(setGlobalSearch(true));
  });

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <TopBar drawerWidth={sidebarOpen ? DRAWER_WIDTH : 0} />
      <Sidebar drawerWidth={DRAWER_WIDTH} open={sidebarOpen} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, md: 3 },
          width: { sm: `calc(100% - ${sidebarOpen ? DRAWER_WIDTH : 0}px)` },
          transition: 'width 200ms ease',
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
      <GlobalSearch />
    </Box>
  );
}
